module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Folder-thunder-c0a50e94be477ae19dcf3aa812de2a71.svg";